import axios from "axios"

export const config = {
    // Ztpl
    // appUrl: "/precisioncontractdriving/",
    // imageUrl: "https://ztpl.net/precisioncontractdriving/backend/public/images/",
    // ClientUrl: "https://ztpl.net/precisioncontractdriving/instructor/sign-up",
    // StudentUrl: "https://ztpl.net/precisioncontractdriving/student",

    // Live
    appUrl: "/",
    imageUrl: "https://api.precisiondriving.uk/public/images/",
    ClientUrl: "https://precisiondriving.uk/instructor/sign-up",
    StudentUrl: "https://precisiondriving.uk/student"

    // Demo
    // appUrl: "/",
    // imageUrl: "https://apidemo.precisiondriving.uk/public/images/",
    // ClientUrl: "https://demo.precisiondriving.uk/instructor/sign-up",
    // StudentUrl: "https://demo.precisiondriving.uk/student"

    // Local
    // appUrl: "/",
    // imageUrl: "http://192.168.0.113:8000/public/images/",
    // ClientUrl: "http://localhost:3000/instructor/sign-up",
    // StudentUrl: "http://localhost:3000/student"
}

export const axiosInstance = axios.create({
    // baseURL: 'https://ztpl.net/precisioncontractdriving/backend/public/api/'
    baseURL: 'https://api.precisiondriving.uk/public/api/'
    // baseURL: 'https://apidemo.precisiondriving.uk/public/api/'


    // local 
    // baseURL: 'http://192.168.0.113:8000/api'
})